@if (showDreNotification) {
<div class="dst-dre-notification-wrapper">
  <ap-notification id="dre-msg"
                   position="static"
                   [status]="'warning'"
                   [closeable]="true"
                   [animation]="true"
                   [styleClass]="'dst-dre-diagnostic'"
                   (onClose)="onDreNotificationClose()">
  </ap-notification>
</div>
}
<div class="center filled-status-text">
    {{filedStatusTxt}}
</div>
<div class="actions-container">
  <div class="left">
    <ap-button [compact]="true" [btnType]="'primary'" [label]="saveEditBtnText" class="ap-mr-spacing-3 btn-save" [disabled]="disableAll || disabled || (dstSharedService.user.roleLevel < 2) || this.dstSharedService.isFiled"
               (onClick)="save()"></ap-button>
    <ap-button [compact]="true" [btnType]="'secondary'" [label]="cancelCloseBtnText" class="ap-mr-spacing-3 btn-cancel" [disabled]="disableAll"
               (onClick)="cancel()"></ap-button>
    @if (!disableS3Upload && isView) {
<ap-button [compact]="true" [btnType]="'primary'" [label]="'S3 Upload'" class="ap-mr-spacing-3 btn-upload" [disabled]="disableAll || disabledS3"
               (onClick)="saveToS3()">

      @if (disabledS3) {
<i class="fa fa-spin fa-spinner"></i>
}
    </ap-button>
}
    <!-- <ap-checkbox [text]="'Place Holder'" class="a-mx-10" [disabled]="isView || disablePlaceholderForChildStatements || disableAll || disabled"
                 [checked]="isPlaceholderChecked" *ngIf="!noPlaceholder"
                 (onCheck)="onPlaceholderChecked($event)">
    </ap-checkbox> -->
  </div>


  <div class="right">
    @if (isView && (dstSharedService.user.roleLevel >= 3)) {
<ap-button [compact]="true" [btnType]="'secondary'" class="ap-mr-spacing-3 btn-upload"  (onClick)="openAttachmentModal('show-upload-modal')">
                Add Signed Attachment
    </ap-button>
}
    @if (isView) {
<ap-button [compact]="true" [btnType]="'secondary'" [label]="'PDF View'" class="ap-mr-spacing-3 btn-print" [disabled]="disableAll || loadingPdf || statementId === 0"
               (onClick)="viewPdf()">

               <span style="padding-left: 5px;">@if (loadingPdf) {
<i class="fa fa-spin fa-spinner"></i>
}</span>
    </ap-button>
}
    @if (isView) {
<ap-button [compact]="true" [btnType]="'secondary'" [label]="'Stylesheet View'" class="ap-mr-spacing-3 btn-print" [disabled]="disableAll || loadingSS || statementId === 0"
               (onClick)="viewStyleSheet()">

               <span style="padding-left: 5px;">@if (loadingSS) {
<i class="fa fa-spin fa-spinner"></i>
}</span>
    </ap-button>
}
    @if (!hideBackBtn) {
<ap-button [compact]="true" [btnType]="'secondary'" class="ap-mr-spacing-3 btn-back" (onClick)="back()">
      <span class="Appkit4-icon icon-arrow-left-outline"></span>&nbsp;Back
    </ap-button>
}
  </div>
</div>

@if (showPDFViewerModal) {
<ap-modal #pdfViewerModal
         
          [appModalId]="'pdf-viewer'"
          [ariaLabel]="'PDF viewer'"
          [closable]="true"
          [style]="{'width': '75rem'}"
          [contentStyle]="{'height': '80vh'}"
          (onClose)="closePDFViewerModalOk('pdf-viewer')">
  <div class="cda-modal-body">
    @if (stmtDetailsLoaded) {
<gtw-form-review-pdf [rowData]="dstProformaData"
                         [divHeight]="'80vh'"></gtw-form-review-pdf>
}
  </div>
  <ng-template ngTemplate="footer">
    <ap-button [compact]="true" [btnType]="'text'" [label]="'CLOSE'" (onClick)="closePDFViewerModalOk('pdf-viewer')"></ap-button>
  </ng-template>
</ap-modal>
}


@if (showUploadModal) {
<ap-modal #uploadModal
         
          [appModalId]="'show-upload-modal'"
          [ariaLabel]="'Upload Attachments'"
          [title]="'Upload Attachments'"
          [closable]="true"
          [style]="{'width': '75rem'}"
          (onClose)="closeUploadModal('show-upload-modal')">
  <div class="cda-modal-body">
    <ap-badge [styleClass]="'a-mr-10'" [value]="'Note: These files are not included while submitting to IRS.'" [type]="'warning'"></ap-badge>
    <ap-tabset [tabsetId]="'create-disclosure-attachments-tabset'" [styleClass]="'gtw-tabset'" [type]="'underline'" [responsive]="true" [(activeIndex)]="uploadTabIndex">
      <ap-tab [label]="'Attachments List'" >
        <div class="d-flex flex-wrap">
          <div class="flex-fill a-modal-mt-50">
            <div class="ap-mb-spacing-6 d-flex">
              <input aria-label="value seven" class="a-text-input ap-mr-spacing-3 w-auto flex-fill" #searchInput (input)="searchAttachments(searchInput.value)" placeholder="Search Attachments">
            </div>
            <div class="a-color-dark a-font-12 a-btn-md ap-mt-spacing-7 ap-mb-spacing-3">{{(secondaryAttachments$ | async)?.length}}
              Attachments</div>
            <ul class="a-list ap-pr-spacing-7">
              @for (file of secondaryAttachments$ | async; track $index) {
<li class="a-list-item d-flex align-items-center a-border-bt ap-py-spacing-3 justify-content-between">
                <div>
                  <div class="a-h6">{{file.FILE_NAME + '.' + file.FILE_TYPE}}</div>
                  <div class="a-h6 font-weight-normal text-truncate">Uploaded By: {{file.UPDATED_BY}}</div>
                  <div class="a-text-caption a-text-9e9 font-weight-normal">Uploaded on: {{file.UPDATED_ON}}</div>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <ap-button [compact]="true" [btnType]="'primary'" class="ap-mr-spacing-3" (onClick)="downloadFileFromS3(file)">
                      @if (file.isDownloading) {
<ap-loading class="a-mr-10" [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
}
                      @if (!file.isDownloading) {
<span class="Appkit4-icon icon-download-light-fill a-btn-icon"></span>
}Download
                    </ap-button>
                    @if (dstSharedService.user.roleLevel === 5) {
<ap-button [compact]="true" [btnType]="'secondary'" class="ap-mr-spacing-3" (onClick)="deactivateAttachment(file)">
                      @if (file.isDeleting) {
<ap-loading class="a-mr-10" [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
}
                      @if (!file.isDeleting) {
<span class="Appkit4-icon icon-delete-fill a-btn-icon"></span>
}Delete
                    </ap-button>
}
                  </div>
                </div>

              </li>
}
            </ul>
          </div>
        </div>
      </ap-tab>
      @if ((secondaryAttachments$ | async)?.length == 0 && (dstSharedService.user.roleLevel >= 3)) {
<ap-tab [label]="'Upload'">
        <gtw-s3-file-upload (on-s3-file-upload)="onFileUpload($event)"></gtw-s3-file-upload>
      </ap-tab>
}
    </ap-tabset>
  </div>
  <ng-template ngTemplate="footer">
    <ap-button [compact]="true" [btnType]="'text'" [label]="'Close'" (onClick)="closeUploadModal('show-upload-modal')"></ap-button>
  </ng-template>
</ap-modal>
}

